import { useEffect } from "react";

import { usePageNameContext } from "../../contexts/PageTitleContext";
import WorkOrderStats from "../../components/workOrders/WorkOrderStats";
import WorkOrdersTable from "../../components/workOrders/WorkOrdersTable";

export default function WorkOrders() {
  const { setInfo } = usePageNameContext();

  useEffect(() => {
    setInfo({
      name: "Work Orders",
      desc: "Create and manage work orders for your team",
    });
  }, []);

  return (
    <>
      <WorkOrderStats />
      <WorkOrdersTable />
    </>
  );
}
